export default {
    ca: {
        shareSocialNetworks: 'Comparteix a les xarxes socials',
        shareMail: 'Envia l\'enllaç per email',
    },
    es: {
        shareSocialNetworks: 'Comparte en las redes sociales',
        shareMail: 'Envia el enlace por email',
    },
    en: {
        shareSocialNetworks: 'Share on social networks',
        shareMail: 'Send link by email',
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/share-modal/share-modal-translations.js